import { z } from 'zod'

export enum TwilioOnboardingStatus {
  BRAND_PENDING = 'brand_pending',
  BRAND_FAILED = 'brand_failed',
  CAMPAIGN_FAILED = 'campaign_failed',
  NEEDS_PHONE = 'needs_phone',
  READY = 'ready',
  UNDER_REVIEW = 'under_review',
}

export const twilioOnboardingStatusSchema = z.nativeEnum(TwilioOnboardingStatus)
